import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { Menu as Menu$1 } from 'primereact/menu';
import { Button } from '../Button/Button.js';
import { Icon } from '../Icon/Icon.js';
import clsx from 'clsx';

// It throws error, because PrimeNg uses 'aria-hidden=true' - this topic is already addressed in their github issues
function Menu(props) {
  const {
    items,
    buttonProps
  } = props || {};
  const menuRef = useRef(null);
  const toastRef = useRef(null);
  const [isActive, setIsActive] = useState(false);
  const buttonClassName = clsx({
    active: isActive
  }, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.className);
  const menuClassName = clsx({
    contrast: buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.contrast
  }, 'context-menu');
  return jsxs(Fragment, {
    children: [jsx(Toast, {
      ref: toastRef
    }), jsx(Menu$1, {
      className: menuClassName,
      model: items,
      popup: true,
      ref: menuRef,
      id: "popup_menu_left",
      onShow: () => setIsActive(true),
      onBlur: () => setIsActive(false)
    }), jsx(Button, Object.assign({
      icon: jsx(Icon, {
        name: "more_vert"
      }),
      text: !Boolean(buttonProps),
      type: "button",
      iconButton: true
    }, buttonProps, {
      onClick: event => {
        var _a;
        event.stopPropagation();
        if (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onClick) {
          buttonProps.onClick(event);
        }
        (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.toggle(event);
      },
      className: buttonClassName
    }))]
  });
}

export { Menu };
